import React,{useEffect,useRef,useState} from 'react'
import { Box,List,ListItem,ListItemText,CircularProgress, FormControl } from '@mui/material'
import { useDispatch,useSelector } from 'react-redux';
import { api } from '../../../../redux/api';
import { newTemplateActions } from '../../../../redux/slices/newTemplateSlice';
import { useTranslation } from 'react-i18next';
import TPCheckbox from '../../../TemplateProperties/TPCheckbox'

function NtwRepTemplateList(props) {
    const { account } = useSelector(state =>state.queryParams)
    const dispatch = useDispatch();
    const [listData,setListData] = useState([]);
    const [selectedIndex, setSelectedIndex] = React.useState();
    const [isLoading, setIsLoading] = useState(true);
    const [selectedItem,setSelectedItem] = useState('')// re-consider
    const [generateAckOutboundTemplate, setGenerateAckOutboundTemplate] = useState(false);

    const currentScreen = useSelector(state => state.treeData.currentScreen)
    const { t } = useTranslation();
    const errorRef = useRef(null)
    
    const handleListItemClick = (event, index,item) => {
      const templateName = item?.title?.split("-")[0].trim();
      setSelectedIndex(index)
      setSelectedItem(item);
      dispatch(newTemplateActions.setSelectedRepTemplate(item))
      dispatch(newTemplateActions.setTemplateName(templateName || ''))
    };
    useEffect(()=>{
       setIsLoading(true)
        dispatch(
          api.endpoints.getRepositoryFiles.initiate(
            {
              account: account,
              template_type:
                currentScreen === "inbound" ? "INBOUND" : "OUTBOUND",
              path: props.path,
              repo_type: props.repo_type,
              release_key: props.release_key,
              title: props.version,
            },
            { forceRefetch: true }
          )
        ).then((response) => {
          if ( response.error) {
            throw new Error(response.error || response.message || t("BOX_MSG_GENERAL_ERROR"))
          } else if (response.data.current_state === "SUCCESS") {
            setListData(response.data.data || []);
            setIsLoading(false);
          } else if (response.data.current_state === "ERROR") {
            setIsLoading(false);
          }
        })
        .catch(error => {
          errorRef.current.textContent = error || t("BOX_MSG_GENERAL_ERROR")
        })
        .finally(() => setIsLoading(false))
      },[])

    function getListData() {
        const style = {
          width: "100%",
          height: "24px",
          cursor: "pointer",
          display: "flex",
          alignItems: "center",
          borderBottom: "1px solid #e0e0e0",
          fontSize: "14px",
          whiteSpace: "nowrap",
          textOverflow: "ellipsis",
        };
      
        return listData.map((item, index) => (
          <ListItem
            key={index}
            style={{ ...style, 
              borderBottom: index === listData.length - 1 ? "none" : "1px solid #e0e0e0",
              backgroundColor: selectedIndex === index ? "#cbf0ff" : "transparent",
             }}
            onClick={(event) => handleListItemClick(event, index,item)}
            
          >
            <div style={{ display: 'flex'}}>
             <div className="GET_DATA" style={{margin:'auto'}}></div>
             <div style={{ marginLeft: '10px' }}>
              <ListItemText primary={item.title} />
            </div>
          </div>
         </ListItem>
        ));
      }
      
  return (
    <>
      {isLoading ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            minHeight: "100px",
            padding: "20px",
          }}>
          <CircularProgress />
        </Box>
      ) : (
        <Box sx={{height:'100%',border:'none'}}>
          <Box
            sx={{
              width: "100%",
              bgcolor: "background.paper",
              border: "1px solid #e0e0e0",
              borderRadius: "6px",
              maxHeight: 'calc(100% - 30px)',
              // height: "100%",
              minHeight:'60px',
              overflowY: "auto",
              overflowX: "hidden",
            }}>
            <List style={{ padding: "0" }}>
              {listData.length > 0 ? (
                getListData()
              ) : (
                <span style={{ fontSize: "12px", padding: "0 12px" }}>
                  No data available.
                </span>
              )}
            </List>
            <p className="error" ref={errorRef}></p>
          </Box>
          {(listData.length > 0 && currentScreen === 'inbound' && props.src === 'hl7Rep') && (
            <FormControl className="padding-8">
              <TPCheckbox
                label={t("LBL_GENERATE_HL7_ACK")}
                checked={generateAckOutboundTemplate}
                handleCheck={(checked) => {
                  setGenerateAckOutboundTemplate(checked);
                  dispatch(newTemplateActions.setGenerateHL7ACK(checked))
                }}
              />
            </FormControl>
          )}
        </Box>
      )}
    </>
  );
  
}

export default NtwRepTemplateList